import BaseService from './base.service';

class SignatureService extends BaseService {
  async getWorkspaceSignature(workspaceId) {
    return this.get(`/signatures/workspace/${workspaceId}`);
  }

  async getDoctorSignature(userId) {
    return this.get(`/signatures/user/${userId}`);
  }

  async getSignatureById(id) {
    return this.get(`/signatures/${id}`);
  }
}

export default SignatureService;
